// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner[data-v-4cd13b66]{transition:max-height .15s,padding-top .15s,padding-bottom .15s;height:auto;overflow:hidden;max-height:32px}article.relative:hover>.banner[data-v-4cd13b66]{max-height:0;padding-top:0;padding-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
